/**
 * Single Product - Indicator JS
 */

// CSS
import styles from '../scss/single-product-indicator.scss';

const $ = window.jQuery,
  bundleDetails = $('.product-main')
    .find('.product-details')
    .children('.product_cat-indicators');

let bundleButton = {},
  sidebarForm = {},
  mainMinHeight =
    parseInt($('.product-sidebar-inner').css('height')) -
    parseInt($('.product-header').css('height')) +
    120;

if ($('.wcppec-checkout-buttons').length > 0) {
  $('.wcppec-checkout-buttons').remove();
}

$('li').each(function () {
  $(this).html($(this).html().replace('&nbsp;', ''));
});

$('.product-main').css({ minHeight: mainMinHeight });

$('html').on('click', '[data-toggle-full-description]', (event) => {
  event.preventDefault();
  $('.product-short-description').toggleClass('is-hidden');
  $('.product-full-description').toggleClass('is-hidden');
});

if ($('.product-add-to-cart').length > 0) {
  $('html').on('click', '.product-add-to-cart', (event) => {
    $(event.currentTarget).addClass('is-loading');
  });
} else if ($('.single_add_to_cart_button').length > 0) {
  $('html').on('click', '.single_add_to_cart_button', (event) => {
    if (!bundleButton.hasClass('selection-needed')) {
      $(event.currentTarget).addClass('is-loading');
    }
  });
}

$('html').on('change', 'input[name="member_discount_toggle"]', (event) => {
  if ($(event.currentTarget).is(':checked')) {
    $('.product-price-container').addClass('member-discount-price-visible');

    $('#modal-product-member-discount').modal('show');
  } else {
    $('.product-price-container').removeClass('member-discount-price-visible');
  }
});

$('#modal-product-member-discount').on('hidden.bs.modal', (event) => {
  $('input[name="member_discount_toggle"]').prop('checked', false);
  $('.product-price-container').removeClass('member-discount-price-visible');
});

if (bundleDetails.length > 0) {
  const bundleDetailsHeader = $('.product-main')
    .find('.product-details')
    .children('h2')
    .first();

  bundleDetails.find('h1').remove();
  bundleDetails.find('p.price').remove();
  bundleDetails
    .find('.woocommerce-product-details__short-description')
    .remove();
  bundleDetails.find('.bundled_product_images.images').remove();
  bundleDetails.find('.woocommerce').remove();
  bundleDetails.find('.bundle_error').remove();

  $(
    bundleDetails
      .find('.bundled_product.bundled_product_summary.product')
      .get()
      .reverse()
  ).each(function () {
    bundleDetailsHeader.after(
      $(this).find('.bundled_product_excerpt.product_excerpt')
    );
    bundleDetailsHeader.after(
      $(this).find('.bundled_product_title.product_title')
    );
  });

  if ($('.product-includes').length > 0) {
    $('.product-includes').before(bundleDetails);
  } else {
    $('.panel').first().children('.panel-body').append(bundleDetails);
  }

  sidebarForm = $('aside.product-sidebar').find('form.cart');
  bundleButton = sidebarForm.find('button');

  let bundleDropdown = document.createElement('select'),
    noValueOption = document.createElement('option'),
    noValueLabel = document.createTextNode('Choose a trading platform');
  bundleDropdown.setAttribute('id', 'bundle_platform');
  bundleDropdown.setAttribute('name', 'bundle_attribute_pa_platform_all');
  bundleDropdown.setAttribute('data-attribute_name', 'attribute_pa_platform');
  bundleDropdown.setAttribute('data-show_option_none', 'yes');
  noValueOption.setAttribute('value', '');
  noValueOption.appendChild(noValueLabel);
  bundleDropdown.appendChild(noValueOption);
  bundleButton.before(bundleDropdown);

  $('html').on('change', 'select#bundle_platform', (event) => {
    let selectedVal = $(event.currentTarget).val();
    sidebarForm.find('.variations').find('select').val(selectedVal).change();
  });
} else {
  $('#pa_platform option:first').text('Choose a trading platform');
}
